import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';
import type { ConfirmationProps } from './types';

export type ConfirmationQuickViewAtom = {
    isOpen: boolean;
    options: ConfirmationProps;
};

export const ConfirmationQuickViewState = mediatorAtom<ConfirmationQuickViewAtom>({
    isOpen: false,
    options: {
        confirmButtonStyle: 'primary',
        denyButtonStyle: 'secondary'
    }
});

export default function useConfirmationQuickView() {
    return useMediatorState(ConfirmationQuickViewState);
}
